import { render, staticRenderFns } from "./Overzicht.vue?vue&type=template&id=04ffde48&scoped=true&"
import script from "./Overzicht.vue?vue&type=script&lang=js&"
export * from "./Overzicht.vue?vue&type=script&lang=js&"
import style0 from "./Overzicht.vue?vue&type=style&index=0&id=04ffde48&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04ffde48",
  null
  
)

export default component.exports